// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"6b2d5ba0f5cfd4796f07","873":"a234133db77142983406"}[chunkId] + ".js";
};